// Services
import authRegisterService from '@/app/services/auth/auth-register/auth-register-service.js';
import registerService from '@/app/services/main/register/register-service.js';

// Utils
import { vuelidateUtil } from '@/utils/vuelidate-util.js';

// Constants
import { STATUS_CODES, STATUS_MSG } from '@/app/constants/constants.js';

// Third party libraries
import { format } from 'date-fns';

export default {
	name: 'AddHuman',
	data() {
		return {
			inputFields: {
				firstName: '',
				lastName: '',
				email: '',
				selectedTimeZone: 'Australia/Sydney'
			},
			isAgreeTNC: false,
			isAPILoading: false
		}
	},
	computed: {
		validationRules() {
			let fields = {
                inputFields: {
                    firstName: {},
                    lastName: {},
                    email: {}
                }
			}

			fields.inputFields = vuelidateUtil.setFieldsRequired(fields.inputFields, true);
			fields.inputFields = vuelidateUtil.setEmailValidation(fields.inputFields, 'email');

			return fields;
		},
		isDisabled() {
			let disable = false;
			if(this.$v.$invalid || !this.isAgreeTNC || this.isAPILoading) {
				disable = true;
			}
			return disable;
        },
		authStatus() {
			return this.$store.getters.getAuthMessage;
		}
    },
	methods: {
        setActiveComponent() {
			this.$emit('setActiveComponent', 'login');
		},
		onAddHuman() {
			if(this.isDisabled) {
				return;
            }

			this.commitAuthStatus('', '');
            
            this.isAPILoading = true;

			let authServiceDetails = {
                email: this.inputFields.email,
                first_name: this.inputFields.firstName,
                last_name:  this.inputFields.lastName,
                password: 'DDmX56AEZxOqL', // Default Password to bypass Auth Service old_password requirement.
                resume: `${window.location.origin}/set-password`
            };

			let registerDetails = {
                formDetails: {
                    "petDetails": {
                        "name": this.$store.getters.getAddPetDetails.name,
                        "breedId": this.$store.getters.getAddPetDetails.breedId,
                        "birthdate": format(new Date(this.$store.getters.getAddPetDetails.birthdate.replace(/-/g, ' ')), 'yyyy-MM-dd'),
                        "gender": this.$store.getters.getAddPetDetails.gender
                    },
                    "userDetails": {
                        "firstName": this.inputFields.firstName,
                        "lastName": this.inputFields.lastName,
                        "defaultTimezone": this.inputFields.selectedTimeZone,
                        "email": this.inputFields.email
                    },
                },
				petImg: this.$store.getters.getAddPetDetails.petImageUpload[0]
            };

            // auth service register api
            authRegisterService.putAuthRegister(authServiceDetails)
                .then(res => {
                    if (res.data.status === STATUS_MSG.AUTH_SERVICE_STATUS_SUCCESS_MSG) {

                        // lmdc register api
                        registerService.postRegister(registerDetails)
                            .then(resp => {
                                if (resp.status === STATUS_CODES.SUCCESS_NO_CONTENT) {
                                    this.isAPILoading = false;
            
                                    // clear stored pet Details
                                    this.$store.commit('clearAddPetDetails');

                                    this.$swal({
                                        imageUrl: `${require('@/assets/images/_shared/success-dog.png')}`,
                                        imageAlt: 'Success Dog',
                                        title: 'Awesome!',
                                        text: 'Please check your email for verification.',
                                        confirmButtonColor: '#4B8BFF',
                                        confirmButtonText: 'Got it',
                                        showCloseButton: true,
                                    }).then(() => {
                                        this.$router.push('/login');
                                    });
                                } else {
									this.isAPILoading = false;
                                    this.authStatus = {
                                        status: 'failed',
                                        messages: res.data.errors
                                    };
                                    this.commitAuthStatus('failed', res.data.errors);
                                }
                            })
                    } else {
						this.isAPILoading = false;
                        this.authStatus = {
                            status: 'failed',
                            messages: [{
								message: res.data.message
							}]
                        };
                        this.commitAuthStatus('failed', [{msg: res.data.message}])
                    }
                });
		},
		commitAuthStatus(status, message) {
        	this.$store.commit('setAuthMessage', {status, message});
		}
	},
	validations() {
		return this.validationRules;
	}
}